import { ROUTES } from '@routes/paths';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { APButton } from '@components/atoms/APButton';
import { Header } from '@components/atoms/Header';
import { Typography } from '@components/atoms/Typography';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className="w-full flex flex-col items-center justify-center py-10">
        <div className="text-center max-w-md">
          <Typography variant="h1" weight={600} text="404" className="text-6xl mb-4" />
          <Typography textKey="CommonMessages.notFound.title" className="text-xl mb-8" />
          <APButton
            textKey={'CommonMessages.notFound.action'}
            size="large"
            onClick={() => navigate(ROUTES.HOME)}
          />
        </div>
      </div>
    </>
  );
};
